import React, { useCallback, useMemo } from 'react';
import {
    Route, Routes, useNavigate, useParams,
} from 'react-router-dom';
import { useClientLayout } from 'pages/ClientOverview/hooks/useClientLayout';
import RouteBasedStepperLayout from 'prodivers/RouteBasedStepperLayout';
import { flattenSteps } from 'utils/stepDefintion';
import { useTranslation } from 'react-i18next';
import { useClientProfile } from 'prodivers/clientProfile';
import useCreateNewCaseFlow from './hooks/useCreateNewCaseFlow';
import { useCreateNewCaseLayout } from './hooks/useCreateNewCaseLayout';
import { StepControllerProvider } from '../../../../../../components/Stepper/RouteBasedStepper/StepControllerContext';

const Router = () => {
    const { dfsClientId } = useParams();
    const navigate = useNavigate();
    const { t, i18n: { language } } = useTranslation();
    const {
        clientName,
    } = useClientProfile();
    const { stepsBasedOnState } = useCreateNewCaseFlow();
    const steps = useMemo(() => flattenSteps(stepsBasedOnState), [stepsBasedOnState]);

    const headerNavLeftButtonOnLeftButtonClick = useCallback(
        () => { navigate(`/client/${dfsClientId}/`); },
        [dfsClientId],
    );

    const headerNavLeftButton = useMemo(
        () => ({ type: 'login', label: `${t('clientDashboard.backTo')} ${clientName}` }),
        [clientName, language],
    );

    useClientLayout(
        false,
        false,
        headerNavLeftButton,
        headerNavLeftButtonOnLeftButtonClick,
    );

    return (
        <StepControllerProvider>
            <RouteBasedStepperLayout dataSource={useCreateNewCaseLayout}>
                <Routes>
                    {Object.keys(steps).map((key) => {
                        const route = steps[key];
                        const Component = route.component;

                        return (
                            <Route
                                path={route.url}
                                key={key}
                                element={<Component {...{ datasource: route.datasource }}/>}
                            />
                        );
                    })}
                </Routes>
            </RouteBasedStepperLayout>
        </StepControllerProvider>
    );
};

Router.displayName = 'Router';

export default Router;
